import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

export default function ActiveFilters({ 
  filters, 
  sortBy, 
  removeFilter, 
  clearFilters,
  sortOptions,
  showBrowseAll,
  onClearBrowseAll
}) {
  const hasActiveFilters = filters.searchQuery || filters.category || filters.priceRange || 
                          filters.merchant.length > 0 || filters.tags.length > 0;

  if (!hasActiveFilters && !sortBy && !showBrowseAll) return null;

  const priceRanges = [
    { value: '0-25', label: 'Under $25' },
    { value: '25-50', label: '$25 - $50' },
    { value: '50-100', label: '$50 - $100' },
    { value: '100-', label: '$100+' }
  ];

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {showBrowseAll && (
        <div 
          data-testid="active-filter-browse-all"
          className="flex items-center gap-2 px-3 py-2 rounded-full text-sm font-medium"
          style={{background: '#9E6752', color: 'white'}}
        >
          <span>Browse All</span>
          {onClearBrowseAll && (
            <button onClick={onClearBrowseAll} data-testid="clear-browse-all-btn">
              <X className="w-3 h-3" />
            </button>
          )}
        </div>
      )}
      {filters.category && (
        <div 
          className="flex items-center gap-2 px-3 py-2 rounded-full text-sm font-medium"
          style={{background: '#FED7A5', color: '#20212B'}}
        >
          <span>{filters.category}</span>
          <button onClick={() => removeFilter('category')}>
            <X className="w-3 h-3" />
          </button>
        </div>
      )}
      {filters.priceRange && (
        <div 
          className="flex items-center gap-2 px-3 py-2 rounded-full text-sm font-medium"
          style={{background: '#73766A', color: 'white'}}
        >
          <span>{priceRanges.find(r => r.value === filters.priceRange)?.label}</span>
          <button onClick={() => removeFilter('priceRange')}>
            <X className="w-3 h-3" />
          </button>
        </div>
      )}
      {sortBy && (
        <div 
          className="flex items-center gap-2 px-3 py-2 rounded-full text-sm font-medium"
          style={{background: '#9E6752', color: 'white'}}
        >
          <span>{sortOptions.find(o => o.value === sortBy)?.label}</span>
          <button onClick={() => removeFilter('sort')}>
            <X className="w-3 h-3" />
          </button>
        </div>
      )}
      {filters.merchant.map(merchant => (
        <div 
          key={merchant}
          className="flex items-center gap-2 px-3 py-2 rounded-full text-sm font-medium"
          style={{background: '#2D4354', color: 'white'}}
        >
          <span>{merchant}</span>
          <button onClick={() => removeFilter('merchant', merchant)}>
            <X className="w-3 h-3" />
          </button>
        </div>
      ))}
      {filters.tags.map(tag => (
        <div 
          key={tag}
          className="flex items-center gap-2 px-3 py-2 rounded-full text-sm font-medium"
          style={{background: '#2D4354', color: 'white'}}
        >
          <span>{tag}</span>
          <button onClick={() => removeFilter('tag', tag)}>
            <X className="w-3 h-3" />
          </button>
        </div>
      ))}
      <Button
        onClick={clearFilters}
        variant="ghost"
        size="sm"
        style={{color: '#9E6752', fontWeight: '600'}}
      >
        Clear All
      </Button>
    </div>
  );
}
